export const setItem = <T,>(key: string, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getItem = <T,>(key: string): T | undefined => {
  const storageValue = localStorage.getItem(key);

  if (storageValue) return JSON.parse(storageValue);
};
